<!--
 * Created by JackCui on 2021/9/27
 -->
<template>
  <div
    :class="getSyClass()"
    :style="{width: width}"
  ><el-form-item
      v-bind="{...$props, ...$attrs}"
      v-on="$listeners"
      v-if="!newFollow && computedSpan"
      :labelWidth='labelWidth'
      :class="getElClass()"
      :style="{width: width ? '100%' : ''}"
      ref="elFormItem"
    >
      <template slot="label">
        <slot name="label">
          <template v-if="!removeLabel">
            <span>
              <slot name="beforeLabel"></slot><span v-if="!(!label || newHideLabel)" class="mod-paas-edit-item-label-text">{{label}}: <el-tooltip
                v-if="labelTip || $slots.labelTipContent"
                effect="dark"
                popperClass="sy-tooltip sy-form-item-tooltip"
                :content="labelTip"
                placement="top-start"
              >
                <template slot="content">
                  <slot name="labelTipContent"></slot>
                </template>
                <i class="el-icon-warning iconTips"></i>
              </el-tooltip></span>
            </span>
          </template>
        </slot>
      </template>
      <template slot="error">
        <slot name="error"/>
      </template>
      <template slot="default">
        <slot/>
      </template>
    </el-form-item><div v-if="newFollow" class="follow-box" :class="getSpanClass()">
      <span v-if="!newHideLabel && label" class="follow-label">
        <slot name="beforeLabel"></slot>{{label}}: <el-tooltip
          v-if="labelTip || $slots.labelTipContent"
          effect="dark"
          popperClass="sy-tooltip sy-form-item-tooltip"
          :content="labelTip"
          placement="top-start"
        >
          <template slot="content">
            <slot name="labelTipContent"></slot>
          </template>
          <i class="el-icon-warning iconTips"></i>
        </el-tooltip>
      </span><span class="follow-conent">
        <slot/>
      </span>
    </div>
  </div>

</template>

<script>
  import {FORM_POSITION_SPAN} from './static'
  export default {
    name: 'form-item',
    props: {
      // 字段名称
      label: {
        type: String,
        default: ''
      },
      // 字段校验规则
      rules: Array,
      // 表单域 model 字段，在使用 validate、resetFields 方法的情况下，该属性是必填
      prop: String,
      // 是否隐藏label
      hideLabel: {
        type: Boolean,
        default: undefined
      },
      // 是否跟随
      follow: {
        type: Boolean,
        default: undefined
      },
      // 通栏长度是否跟其他列对齐
      banner: {
        type: Boolean,
        default: true
      },
      // 通栏长度是否跟其他列对齐 new
      isAlign: {
        type: Boolean,
        default: true
      },
      // label Tip提示
      labelTip: {
        type: String,
        default: ''
      },
      // sy-form-item 的 class
      syFormClass: {
        type: String
      },
      // el-form-item 的 class
      elFormClass: {
        type: String
      },
      // 页面类型 plain 一般   popup 弹窗
      pageType: {
        type: String
      },
      // 表单域标签的的宽度
      labelWidth: {
        type: String,
        default: ''
      },
      // 几列展示 0 宽度100% / 1代表一列...
      span: {
        type: [String]
      },
      // 组件宽度
      width: {
        type: [String]
      },
      // 内容区是否为文本
      isText: {
        type: Boolean,
        default: undefined
      },
      // 组件样式类型  mini用于table里边
      styleType: {
        type: String
      },
      // 是否删除label dom节点 
      removeLabel: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        apiPosition: 'right',
        position: 'right'
      }
    },
    inject: ['syForm', 'elForm'],
    async created () {
      if (this.newStyleType === 'mini' && !this.labelWidth) {
        this.labelWidth = '72px'
      }
    },
    methods: {
      resetField () {
        this.$refs['elFormItem'].resetField()
      },
      clearValidate () {
        this.$refs['elFormItem'].clearValidate()
      },
      getSyClass () {
        let classList = ['sy-form-item', this.syFormClass, 'sy-form-item-' + this.newStyleType, 'sy-form-item--' + this.position]
        if (this.computedSpan) classList.push('sy-col-' + this.computedSpan)
        return classList
      },
      getElClass () {
        let classList = ['cur-form-item', this.elFormClass]
        if (this.newHideLabel) classList.push('hide-label')
        if (this.removeLabel) classList.push('remove-label')
        if (this.newIsText) classList.push('is-text')
        if (this.isAlign) {
          classList.push('banner' + this.bannerSpan)
        }
        // 映射word  computedSpan
        const pageType = this.pageType || this.syForm?.pageType || this.elForm?.$attrs?.pageType || 'plain'
        classList.push(pageType + this.computedSpan)
        return classList
      },
      getSpanClass () {
        const pageType = this.pageType || this.syForm?.pageType || this.elForm?.$attrs?.pageType || 'plain'
        return (pageType + this.computedSpan)
      },
      async computedPosition () {
        let apiPosition = await this.$CatchStore?.getInterfaceData('getType').getter()
        if (apiPosition) this.apiPosition =  apiPosition
        if (this.newStyleType === 'mini') {
          this.position = 'right'
        } else {
          this.position = this.syForm?.labelPosition || this.apiPosition
        }
      }
    },
    computed: {
      computedSpan () {
        return [
          this.span,
          this.syForm?.span,
          this.elForm?.$attrs.span,
          FORM_POSITION_SPAN[this.position],
          2
        ].find(v => (v === 0 || (v && v !== 'auto')))
      },
      newHideLabel () {
        return [
          this.hideLabel,
          this.syForm?.hideLabel,
          this.elForm?.$attrs.hideLabel,
          false
        ].find(v => (v === true || v === false))
      },
      newIsText () {
        return [
          this.isText,
          this.syForm?.isText,
          this.elForm?.$attrs.isText,
          false
        ].find(v => (v === true || v === false))
      },
      newFollow () {
        const follow = [
          this.follow,
          this.syForm?.follow,
          this.elForm?.$attrs.follow,
          false
        ].find(v => (v === true || v === false))
        if (this.syForm?.labelPosition) this.position = this.syForm.labelPosition
        if (!(follow || this.syForm?.labelPosition)) {
          this.computedPosition()
        }
        return follow
      },
      newStyleType () {
        return [
          this.styleType, 
          this.syForm?.styleType, 
          this.elForm?.$attrs.styleType, 
          'small'
        ].find(v => v)
      },
      bannerSpan () {
        return [
          this.syForm?.span,
          this.elForm?.$attrs.span,
          FORM_POSITION_SPAN[this.position],
          2
        ].find(v => (v !== undefined && v !== 'auto'))
      }
    }
  }
</script>

<style scoped lang="scss">
  .sy-form-item {
    .follow-box{
      display: flex;
      flex-direction: row;
      .follow-label {
        display: inline;
        padding-right: 8px;
        vertical-align: top;
        font-size: 14px;
        color: #636E95;
        letter-spacing: 0;
      }
      
      .follow-conent {
        display: inline;
        flex: 1;
        vertical-align: top;
        word-break: break-all;
      }
    }
    word-break: normal;
    word-wrap: normal;
    padding:0 16px 24px;
    display: inline-block;
    vertical-align: top;
    float: none;
    box-sizing: border-box;
    font-size: 14px;

    .el-form-item {
      margin-bottom: 0;
      ::v-deep .el-form-item__label {
        
        .iconfont{
          margin-left: 4px;
          display: inline-block;
        }

      }

      ::v-deep .el-form-item__content {
        padding-bottom: 0;
        line-height: 20px;
        color: #2E3656;
      }
    }
    .mod-paas-edit-item-label-text {
      display: inline;
      word-break: break-word;
    }

    .sy-form-item-tooltip {
      max-width: 400px !important;
      font-size: 12px;
      line-height: 16px;
      white-space: pre-line;
      .iconTips {
        color: #ddd;
      }
    }
    .el-form-item{
      width: 310px;
      line-height: 20px;
    }
    .plain3 {
      width: 310px;
    }
    .plain2 {
      width: 400px;
    }
    .plain1 {
      width: 500px;
    }
    .popup1 {
      width: 400px;
    }
    .popup2 {
      width: 380px;
    }
    .popup3 {
      width: 280px;
    }
    &.sy-form-item-mini {
      padding:0 0 8px;
      width: 100%;
      font-size: 12px;
      // vertical-align: baseline;
      .cur-form-item {
        ::v-deep {
          .el-form-item__label, .el-form-item__content {
            font-size: 12px;
            line-height: 16px;
            padding-bottom: 0;
          }
          .el-form-item__label {
            width: 72px;
            text-align: left;
            padding-right: 8px;
            letter-spacing: 0;
            font-weight: 400;
            padding-top: 8px;
            float: left;
          }
          .el-form-item__label:before {
              content: "";
              margin-right: 0;
          }
          .el-form-item__content {
            margin-left: 72px;
            padding-top: 0;
          }
          .el-form-item__error {
            text-align: left;
          }
        }
        width: auto;
      }
      .is-text {
        ::v-deep .el-form-item__content {
          padding-top: 6px;
        }
      }
      .follow-box {
        width: 100%;
        display: inline;
        .follow-label {
          font-size: 12px;
          padding-right: 0;
          max-width: auto;
        }
      }
      .hide-label {
        ::v-deep {
          & > .el-form-item__label {
            display: none;
          }
          & > .el-form-item__label-wrap {
            display: none;
          }
        }
      }
    }
    
  }
  .sy-col-0 {
    width: 100%;
    .el-form-item {
      width: 100%;
    }
    // sass变量  banner
    .plain0.banner3 {
      width: calc((100% + 32px) * 2 / 3 + 310px);
    }
    .plain0.banner2 {
      width: calc((100% + 32px) * 0.5 + 400px);
    }
    .plain0.banner1 {
      width: 500px;
    }
    .popup0.banner3 {
      width: calc((100% + 32px) * 2 / 3 + 280px);
    }
    .popup0.banner2 {
      width: calc((100% + 32px) * 0.5 + 380px);
    }
    .popup0.banner1 {
      width: 400px;
    }
  }
  .sy-col-1 {
    width: 100%;
  }
  .sy-col-2 {
    width: 50%;
  }
  .sy-col-3 {
    width: 33.33%;
  }

  .sy-form-item--right, .sy-form-item--left {
    ::v-deep .el-form-item__label {
      padding-right: 8px;
      font-size: 14px;
      color: #636E95;
      letter-spacing: 0;
      font-weight: 400;
      line-height: 20px;
      padding-top: 6px;
      padding-bottom: 0;
    }
    ::v-deep .el-form-item__error {
      top: auto;
      position: static;
      padding-bottom: 2px;
    }
    .hide-label {
      ::v-deep {
        & > .el-form-item__label {
          display: none;
        }
        & > .el-form-item__label-wrap {
          display: none;
        }
      }
    }
    .is-text {
      ::v-deep {
        .el-form-item__content {
          padding-top: 6px;
        }
      } 
    }
  }
  .sy-form-item--top {
    ::v-deep .el-form-item__label {
      font-size: 14px;
      color: #636E95;
      letter-spacing: 0;
      line-height: 20px;
      font-weight: 400;
      padding-bottom: 8px;
      min-height: 28px;
    }
    ::v-deep .el-form-item__error {
      position: static;
      padding-bottom: 2px;
    }

    ::v-deep .el-form-item__content {
      display: block;
    }
    .hide-label {
      ::v-deep {
        &>.el-form-item__label:before {
          content: "";
        }
      }
    }
  }
  .sy-form-item:has(.el-form-item__error) {
    margin-bottom: 20px;
  }

  .hide-label {
    font-size: 10px;
    margin-left: 0;

    // ::v-deep & > .el-form-item__label {
    //   display: none;
    // }
    // ::v-deep & > .el-form-item__label-wrap {
    //   display: none;
    // }

    ::v-deep & > .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .remove-label {
    ::v-deep & > .el-form-item__label {
      display: none;
    }
  }
</style>
<style lang="scss">
.sy-form-item-tooltip {
    max-width: 400px !important;
    white-space: pre-line;
}
</style>